import * as React from "react"

import type {
  SmithersBulkImportProgressJob,
  SmithersBulkImportUploadResult,
} from "@/types/smithers-bulk-import"

export const SMITHERS_BULK_IMPORT_JOB_ID_STORAGE_KEY = "smithersBulkImportJobId"
export const SMITHERS_BULK_IMPORT_NOTIFIED_JOB_ID_STORAGE_KEY =
  "smithersBulkImportNotifiedJobId"

export interface SmithersBulkImportJobContextValue {
  jobId: string | null
  job?: SmithersBulkImportProgressJob
  error?: unknown
  isLoading: boolean
  startJob: (result: SmithersBulkImportUploadResult) => void
  dismissJob: () => void
}

export const SmithersBulkImportJobContext =
  React.createContext<SmithersBulkImportJobContextValue | null>(null)

export function useSmithersBulkImportJobContext(): SmithersBulkImportJobContextValue {
  const context = React.useContext(SmithersBulkImportJobContext)
  if (!context) {
    throw new Error("useSmithersBulkImportJobContext must be used inside SmithersBulkImportJobProvider")
  }
  return context
}
